<template>
  <div
    class="personal_center_container d-flex justify-center mt-10 flex-grow-1"
    style="width: 100%; background-color: #f8f9fb;"
  >
    <div
      class="personal_center"
      style="height: 90%; width: 85%; background-color: #ffffff;"
    >
      <v-tabs class="tabs" vertical style="height: 100%;" color="#3f57bb">
        <v-tab class="d-flex justify-start">
          <v-icon left>mdi-account</v-icon>
          {{ $i18n.t("personal.account_information") }}
        </v-tab>
        <v-tab class="d-flex justify-start">
          <v-icon left>mdi-lock</v-icon>
          {{ $i18n.t("personal.security_setting") }}
        </v-tab>
        <v-tab class="d-flex justify-start">
          <v-icon left>mdi-information</v-icon>
          {{ $i18n.t("personal.authorization_message") }}
        </v-tab>
        <v-tab class="d-flex justify-start">
          <v-icon left>mdi-pencil-circle</v-icon>
          {{ $i18n.t("personal.feedback") }}
        </v-tab>
        <v-tab class="d-flex justify-start" @click="getAllOrders">
          <v-icon left>event</v-icon>
          {{ $i18n.t("personal.order_management") }}
        </v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text style="padding-top: 0;">
              <v-row justify="center" align="center">
                <!--                <v-col cols="12" class=" d-flex justify-start align-center">-->
                <!--                  <div class="common-font-black-bold mr-5">头像</div>-->
                <!--                  <v-sheet color="orange lighten-2" width="40px" height="40px"></v-sheet>-->
                <!--                  <div class="common-font-color ml-5">修改</div>-->
                <!--                </v-col>-->
                <v-col sm="12" md="6">
                  <div class="common-font-black-bold mb-2">
                    {{ $i18n.t("personal.full_name") }}
                  </div>
                  <label>
                    <input v-model.trim="userInformation.name" type="text" />
                  </label>
                </v-col>
                <v-col md="6" sm="12">
                  <div class="common-font-black-bold mb-2">
                    {{ $i18n.t("personal.telephone") }}
                  </div>
                  <label>
                    <input
                      v-model.trim="userInformation.telephone"
                      type="text"
                    />
                  </label>
                </v-col>
                <v-col md="6" sm="12">
                  <div class="common-font-black-bold mb-2">
                    {{ $i18n.t("personal.company") }}
                  </div>
                  <label>
                    <input v-model.trim="userInformation.company" type="text" />
                  </label>
                </v-col>
                <v-col md="6" sm="12">
                  <div class="common-font-black-bold mb-2">
                    {{ $i18n.t("personal.title") }}
                  </div>
                  <label>
                    <input
                      v-model.trim="userInformation.jobTitle"
                      type="text"
                    />
                  </label>
                </v-col>
                <v-col cols="12">
                  <div class="common-font-black-bold mb-2">
                    {{ $i18n.t("personal.address") }}
                  </div>
                  <label>
                    <input v-model.trim="userInformation.address" type="text" />
                  </label>
                </v-col>

                <v-col cols="12">
                  <div>
                    <v-btn @click="changeUserInfo" outlined color="#3f57bb"
                      >{{ $i18n.t("personal.change") }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text style="padding-top: 0;">
              <v-row justify="start" align="center">
                <v-col cols="12" class="d-flex align-center">
                  <div class="common-font-black-bold mar-2">
                    {{ $i18n.t("personal.email") }}:
                  </div>
                  <div class="common-font-black-normal ml-2">
                    {{ user.email }}
                  </div>
                </v-col>
                <!--                <v-col cols="12" class="d-flex  align-center">-->
                <!--                  <div class="common-font-black-bold mr-2">备用邮箱 :</div>-->
                <!--                  <input type="text" placeholder="5465465465@qq.com">-->
                <!--                  <div class="common-font-color ml-2"> 修改</div>-->
                <!--                </v-col>-->
                <!--                <v-col cols="12" class="d-flex  align-center">-->
                <!--                  <div class="common-font-black-bold mr-2">{{$i18n.t("personal.telephone")}}:</div>-->
                <!--                  <input type="text" placeholder="1111111111">-->
                <!--                  <div class="common-font-color ml-2">修改</div>-->
                <!--                </v-col>-->
                <!--                <v-col cols="12" class="d-flex  align-center">-->
                <!--                  <div class="common-font-black-bold mr-2">绑定微信 :</div>-->
                <!--                  <input type="text" placeholder="545465464">-->
                <!--                  <div class="common-font-color ml-2">修改</div>-->
                <!--                </v-col>-->
                <v-col cols="12" class="d-flex align-center">
                  <div @click="changePassword" class="common-font-color">
                    {{ $i18n.t("personal.change_password") }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text style="padding-top: 0;">
              <v-row>
                <v-col
                  cols="12"
                  class="d-flex align-center"
                  style="border-bottom: 1px solid #e8e8e8;"
                >
                  <div
                    class="common-font-black-bold d-flex align-center"
                    style="height: 36px;"
                  >
                    {{ $i18n.t("personal.registration_time") }} :
                    <span class="common-font-black-normal ml-2">
                      {{ user.createTime }}
                    </span>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="d-flex align-center"
                  style="border-bottom: 1px solid #e8e8e8;"
                >
                  <div
                    class="common-font-black-bold d-flex align-center"
                    style="height: 36px;"
                  >
                    {{ $i18n.t("personal.authorization_data") }} :
                    <span class="common-font-black-normal ml-2">
                      {{ user.authTime }}
                    </span>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="d-flex align-center"
                  style="border-bottom: 1px solid #e8e8e8;"
                >
                  <div
                    class="common-font-black-bold d-flex align-center"
                    style="height: 36px;"
                  >
                    {{ $i18n.t("personal.Expiration_date_of_authorization") }} :
                    <span class="common-font-black-normal ml-2">
                      {{ user.expiredTime }}
                    </span>
                  </div>
                  <!--                  <div class="common-font-color ml-5">-->
                  <!--                    {{$i18n.t("personal.Extend_the_authorization")}}-->
                  <!--                  </div>-->
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text style="padding-top: 0;">
              <v-row>
                <!--                <v-col cols="12">-->
                <!--                  意见反馈-->
                <!--                </v-col>-->
                <!--                <v-col md="6" ms="12">-->
                <!--                  <v-textarea-->
                <!--                          no-resize="true"-->
                <!--                          outlined-->
                <!--                          name="input-7-4">-->

                <!--                  </v-textarea>-->
                <!--                </v-col>-->
                <!--                <v-col cols="12">-->
                <!--                  联系方式-->
                <!--                </v-col>-->
                <!--                <v-col cols="12">-->
                <!--                  <input type="text" placeholder="请输入联系方式">-->
                <!--                </v-col>-->
                <!--                <v-col cols="12">-->
                <!--                  <button class="common-button" style="width: 60px">提交</button>-->
                <!--                </v-col>-->
              </v-row>
              <v-row justify="start" align="center">
                <v-col cols="12">
                  <div class="common-font-black-bold">
                    {{
                      $i18n.t(
                        "personal.Please contact customer service if you have any questions"
                      )
                    }}
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="common-font-black-bold">TEL: 0551-62886576</div>
                </v-col>
                <v-col>
                  <div class="common-font-black-bold">
                    {{ $i18n.t("personal.work time") }}：9:30~12:00 14:00~17:30
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item class="orderItem-container" style="background: #ffffff;">
          <v-card
            v-if="showOrder"
            flat
            class="order-wrapper"
            style="margin: 0 30px;"
          >
            <div class="d-flex justify-space-between align-center mt-5">
              <span>{{ $i18n.t("personal.all_orders") }}</span>
              <v-btn color="rgb(63, 87, 187)" @click="toAuthor" outlined
                >{{ $i18n.t("personal.Renew authorization") }}
              </v-btn>
            </div>
            <div>
              <div
                class="d-flex align-center my-5"
                style="background: #e7e7e7; height: 40px; padding: 0 20px;"
              >
                <div style="width: 55%;">
                  {{ $i18n.t("personal.Merchandise_information") }}
                </div>
                <div style="width: 15%; text-align: center;">
                  {{ $i18n.t("personal.payable") }}
                </div>
                <div style="width: 15%; text-align: center;">
                  {{ $i18n.t("personal.order_status") }}
                </div>
                <div style="width: 15%; text-align: right;">
                  {{ $i18n.t("personal.invoice_management") }}
                </div>
              </div>
              <div
                v-if="allOrder.length === 0"
                class="text-center common-font-black-normal"
              >
                {{
                  $i18n.t(
                    "personal.There is no relevant order information at present"
                  )
                }}
              </div>
              <OrderItem
                v-for="item in allOrder"
                :key="item.id"
                :order="item"
                @changeShowOrder="changeShowOrder"
              />
            </div>
          </v-card>
          <v-card
            v-else
            flat
            class="mx-8"
            style="position: relative; min-width: 600px;"
          >
            <v-row>
              <v-col cols="12">
                <div>
                  {{ $i18n.t("personal.Invoice amount") }}: ￥{{
                    invoiceOrder.invoiceAmount
                  }}
                </div>
              </v-col>
              <!--              <v-col cols="12">-->
              <!--                <div>-->
              <!--                  {{ $i18n.t("personal.service name") }}:-->
              <!--                  {{ $i18n.t("personal.Software service fee") }}-->
              <!--                </div>-->
              <!--              </v-col>-->
              <v-col cols="6">
                <div>{{ $i18n.t("personal.Name of purchaser") }}:</div>
                <input v-model.trim="invoiceOrder.companyName" type="text" />
              </v-col>
              <v-col cols="6">
                <div>{{ $i18n.t("personal.Tax identification number") }}:</div>
                <input v-model.trim="invoiceOrder.taxId" type="text" />
              </v-col>
              <v-col cols="6">
                <div>{{ $i18n.t("personal.Invoice receiving address") }}:</div>
                <label>
                  <input v-model.trim="invoiceOrder.address" type="text" />
                </label>
              </v-col>

              <v-col cols="6">
                <div>{{ $i18n.t("personal.Contacts") }}:</div>
                <input v-model.trim="invoiceOrder.receiveName" type="text" />
              </v-col>
              <v-col cols="6">
                <div>{{ $i18n.t("personal.Contact number") }}:</div>
                <input v-model.trim="invoiceOrder.receiveTele" type="text" />
              </v-col>
              <v-col cols="12">
                <div>
                  <v-btn color="#3f57bb" outlined @click="getInvoiced"
                    >{{ $i18n.t("personal.Confirm invoice") }}
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" xs="12" md="6">
                <div>
                  {{ $i18n.t("personal.explain") }}：<br />

                  1.{{
                    $i18n.t(
                      "personal.The default payment method of express delivery is cash on delivery"
                    )
                  }}<br />

                  2.{{
                    $i18n.t(
                      "personal.Invoice will be sent within 3 working days"
                    )
                  }}<br />

                  3.{{
                    $i18n.t(
                      "personal.By default it is sent to SF express, and the specific receiving time is subject to the notice of the express company"
                    )
                  }}<br />
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "PersonalCenter",
  data() {
    return {
      userInformation: {
        telephone: "",
        name: "",
        company: "",
        jobTitle: "",
        address: "",
        groupName: "",
      },
      showOrder: true, // 显示订单
      allOrder: [], // 所有订单
      invoiceOrder: {
        invoiceAmount: "", //开票金额
        companyName: "", //公司抬头
        taxId: "", //税号
        address: "", //收件地址
        receiveName: "", //收件人
        receiveTele: "", //收件电话
        oids: [
          //开发票的订单号
        ],
      },
    };
  },
  mounted() {
    this.getUserInformation().then((res) => {
      let user = {
        telephone: "",
        name: "",
        company: "",
        jobTitle: "",
        address: "",
        groupName: "",
      };
      this.userInformation = this.user || user;
    });
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    ...mapMutations(["SET_SNACK_INFO"]),
    ...mapActions([
      "getUserInformation",
      "changeUserInformation",
      "aliInvoice",
      "aliOrder",
    ]),
    required(value) {
      return !!value || this.$i18n.t("login.What is required");
    },
    changePassword() {
      this.$router.push("/change_password");
    },
    changeUserInfo() {
      this.changeUserInformation(this.userInformation).then((res) => {
        if (res.data.code === 200) {
        }
      });
    },
    toAuthor() {
      // 延长授权
      console.log("to Author");
      this.$router.push("/author");
    },
    changeShowOrder(order) {
      this.invoiceOrder.invoiceAmount = order.totalAmount;
      this.invoiceOrder.oids[0] = order.oid;
      this.showOrder = !this.showOrder;
    },
    getAllOrders() {
      this.showOrder = true;
      this.aliOrder().then((res) => {
        this.allOrder = res.data.data;
      });
    },
    getInvoiced() {
      for (let item in this.invoiceOrder) {
        if (!this.invoiceOrder[item]) {
          this.SET_SNACK_INFO({
            status: true,
            color: "error",
            msg: "Please complete all information",
            timeout: 2000,
          });
          return;
        }
      }

      this.aliInvoice(this.invoiceOrder).then((res) => {
        if (res.data.code === 200) {
          this.getAllOrders();
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "../utils/common";

* {
  box-sizing: border-box;
}

.personal_center_container {
  .v-slide-group__content.v-tabs-bar__content {
    width: 200px;
  }

  .v-tabs-items {
    border-left: 1px solid #e8e8e8;
  }

  .v-tab {
    height: 60px !important;
    border-bottom: 1px solid #e8e8e8;
    @include common_font;
  }

  input {
    width: 260px;
    height: 36px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(231, 231, 231, 1);
    padding-left: 10px;
  }
}
</style>
